const prepareShow = specializations => {
  return specializations
}

export default {
  prepareShow
}



// WEBPACK FOOTER //
// ./src/app/professional/curriculum/specializations/resources/methods.js